
import { defineComponent } from "vue";
import { computed, ref } from "vue";

const __default__ = defineComponent({
  name: "ContactSticky",
  props: {
    isMakler: {
      type: Boolean,
      default: false,
    },
    positionX: { type: Number, default: 0 },
    positionY: { type: Number, default: 0 },
    sticky: { type: Boolean, default: true },
  },
  setup(props) {
    const isTelefonAktiv = ref(true);
    const isMailAktiv = ref(false);

    function toggle_telefon() {
      isTelefonAktiv.value = !isTelefonAktiv.value;
      if (isTelefonAktiv.value) {
        isMailAktiv.value = false;
      }
    }

    function toggle_mail() {
      isMailAktiv.value = !isMailAktiv.value;
      if (isMailAktiv.value) {
        isTelefonAktiv.value = false;
      }
    }

    const telefonNummer = computed(() => {
      return props.isMakler ? "040 37663-222" : "040 37663-366";
    });

    const emailAdresse = computed(() => {
      return props.isMakler ? "maklerservice@grundvers.de" : "kundenservice@grundvers.de";
    });

    return {
      props,
      isTelefonAktiv,
      isMailAktiv,
      toggle_telefon,
      toggle_mail,
      telefonNummer,
      emailAdresse,
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "3efc96d8": (_ctx.positionY),
  "3efc96da": (_ctx.positionX)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__